// removed by extract-text-webpack-plugin
module.exports = {"smallButton":"_2E1BI","submit":"_2qNW1","page":"_1SVp-","header":"_3jmlD","note":"_1pmup","label":"_2sYbQ","smallButtonActive":"_1z8pS _2E1BI","reset":"_3DeAJ _2qNW1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Settings.css
// module id = 865
// module chunks = 0